import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import EmailVerification from "./EmailVerification";
import "./Auth.css";
import LandingPage from "../../pages/LandingPage";
import LoginPage from "./LoginPage";

const AuthWrapper = ({ children }) => {
  const { currentUser, isEmailVerified } = useAuth();
  const location = useLocation();

  // Allow /demo route to bypass authentication
  const isDemoRoute = location.pathname === "/demo";

  // Landing Page is public
  if (location.pathname === "/" || location.pathname === "/index.html") {
    return <LandingPage />;
  }

  // Dedicated login page (public)
  if (location.pathname === "/login") {
    // If already logged in, redirect to dashboard
    if (currentUser && isEmailVerified) {
      return <Redirect to="/education" />;
    }
    return <LoginPage />;
  }

  // If user is not authenticated, redirect to /login (unless on demo route)
  if (!currentUser && !isDemoRoute) {
    // Preserve the intended destination
    return (
      <Redirect
        to={`/login?redirect=${encodeURIComponent(
          location.pathname + location.search
        )}`}
      />
    );
  }

  // If user is authenticated but email is not verified (and not a Google user), show verification
  if (
    currentUser &&
    !isEmailVerified &&
    !currentUser.providerData.some(
      (provider) => provider.providerId === "google.com"
    )
  ) {
    return <EmailVerification />;
  }

  // If user is authenticated and email is verified, show the main app
  return children;
};

export default AuthWrapper;
